declare global {
  interface Window {
    fbqplus?: (...args: any[]) => void;
    fbq?: (...args: any[]) => void;
    FB_PIXEL_ID?: string;
  }
}

const IS_DEV = process.env.REACT_APP_ENVIRONMENT !== 'production';

interface FBTrackingEvent {
  content_name?: string;
  content_type?: string;
  content_ids?: string[];
  value?: number | string;
  currency?: string;
  discount?: boolean;
  num_items?: number;
}

class FBTracking {
  track(eventName: string, eventData?: FBTrackingEvent): void {
    if (IS_DEV) {
      console.log(`[FB Pixel Dev] ${eventName}`, eventData);
      return;
    }

    if (typeof window.fbqplus === 'function') {
      window.fbqplus('track', eventName, eventData);
    } else {
      console.warn('Facebook Pixel not loaded');
    }
  }

  trackViewContent(contentName: string): void {
    this.track('ViewContent', {
      content_name: contentName,
      content_type: 'product',
    });
  }

  trackAddToCart(contentName: string): void {
    this.track('AddToCart', {
      content_name: contentName,
    });
  }

  trackAddToWishlist(contentName: string): void {
    this.track('AddToWishlist', {
      content_name: contentName,
      content_type: 'product',
    });
  }

  trackInitiateCheckout(
    contentName: string,
    value: string | number,
    discount: boolean = false
  ): void {
    this.track('InitiateCheckout', {
      content_name: contentName,
      content_type: 'product',
      num_items: 1,
      currency: 'USD',
      value: value,
      discount: discount,
    });
  }

  trackPurchase(
    contentName: string,
    productId: string,
    value: string | number,
    discount: boolean = false
  ): void {
    this.track('Purchase', {
      content_name: contentName,
      content_type: 'product',
      content_ids: [productId],
      value: value,
      currency: 'USD',
      discount: discount,
    });
  }
}

export const fbTracking = new FBTracking();
